import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
export const getExternalAuthUrl = portalId => {
  const googleAppSlug = `/googlemeet-226062/${enviro.getHublet()}`;
  if (portalId) return `${getFullUrl('app')}/in-meeting-experience-crm-install/${portalId}${googleAppSlug}`;
  return `${getFullUrl('app')}/portal-recommend/l?slug=in-meeting-experience-crm-install${googleAppSlug}`;
};
export const getAppDomain = hublet => {
  return getFullUrl(enviro.deployed() ? 'app' : 'local', hublet ? {
    hubletOverride: hublet
  } : undefined);
};